/*
 * File: 美的会议下载提示页
 * File Created: 2021-05-13 10:14:41 am
 * Author: huangxl (huangxl20@meicloud.com)
 * -----
 * Last Modified: 2021-09-09 4:04:44 pm
 * Modified By: huangxl (huangxl20@meicloud.com)
 */

<template>
  <div
    :class="[
      'midea-meeting-tips',
      isPC ? 'midea-meeting-tips-pc' : 'midea-meeting-tips-mb'
    ]">
    <div class="container">
      <div class="app-icon">
        <img src="../../assets/images/icons/midea-meeting.png" alt="" width="60" height="60">
        <span>{{ $t('meeting.openMideaMeeting') }}</span>
      </div>
      <div class="text-wrapper">
        <span class="text">{{ $t('meeting.clickDownload') }}</span>
        <span class="text">
          {{ $t('meeting.installedMideaMeeting') }}
          <span
            class="blue"
            @click="handleOpenMideaMeeting">
            {{ $t('meeting.clickHere') }}
          </span>
        </span>
        <span class="text">{{ $t('meeting.browserDialogOpened') }}</span>
        <span class="text">
          {{ $t('meeting.clickOpenMideaMeetingBtn') }}
        </span>
      </div>
      <mx-button
        type="info"
        block
        @click="goToDownloadMideaMeeting">
        {{ $t('meeting.donwloadImed') }}
      </mx-button>
    </div>
  </div>
</template>

<script>
import MxButton from '@/components/mx-button'
import { isPC, genrateMideaMeetingOpenUrl, getMideaMeetingDownloadUrl } from '@/utils'
import { mapGetters } from 'vuex'

export default {
  name: 'midea-meeting-tips',
  components: {
    MxButton
  },
  data () {
    return {
      isPC: isPC()
    }
  },
  computed: {
    ...mapGetters(['browserMeetingUrl']),
    meetingUuid() {
      return this.$route.query.meetingUuid
    },
    umeetUuid() {
      return this.$route.query.umeetUuid
    },
    meetingNo() {
      return this.$route.query.meetingNo
    },
    secure() {
      return this.$route.query.secure
    }
  },
  methods: {
    handleOpenMideaMeeting() {
      this.$_dataRanger.send('button_click', {
        module: '视频会议',
        sub_module: '会议中转页',
        page_name: '会议中转页',
        page_path: '会议中转页',
        element_content: 'MideaMeeting入会'
      })
      const mideaMeetingSchemeUrl = genrateMideaMeetingOpenUrl(this.umeetUuid, this.meetingNo)
      window.location.replace(mideaMeetingSchemeUrl)
    },
    goToDownloadMideaMeeting() {
      this.$_dataRanger.send('button_click', {
        module: '视频会议',
        sub_module: '会议中转页',
        page_name: '会议中转页',
        page_path: '会议中转页',
        element_content: '下载MideaMeeting'
      })
      const url = getMideaMeetingDownloadUrl()
      window.location.replace(url)
    }
  }
}
</script>

<style lang='less' scoped>
  @import '~@/assets/less/home.less';
  .midea-meeting-tips {
    .app-icon {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 40px 0 27px 0;
      font-size: 14px;
      & > img {
        margin-bottom: 20px;
      }
      & > span {
        font-size: 18px;
        font-weight: 500;
        line-height: 25px;
        text-align: center;
      }
    }
    .text-wrapper {
      display: flex;
      flex-direction: column;
      // align-items: center;
      font-size: 14px;
      line-height: 22px;
      color: #7F7F7F;
      margin-bottom: 32px;
      text-align: center;
      .title {
        color: #333333;
      }
      .blue {
        color: #0086FF;
        &:hover {
          cursor: pointer;
        }
      }
    }
    /deep/ .van-nav-bar {
      background: #F2F2F2;
      .van-icon {
        color: #545454;
      }
      .van-nav-bar__left {
        padding-left: 0;
      }
    }
  }
</style>
